import type { ValueOf } from 'type-fest'
import { createReducer } from 'lib/redux/reducerUtils'

// NOTE: This state is meant to stay relevant only to the Luxkit modal context.
// No other stateful logic should be handled here.
// If you think something relevant to the Luxkit modal is missing here,
// please consult with the Luxkit maintainers.

export default interface LuxKitModalBehaviourState {
  bodyHasReachedEnd: boolean
  bodyHasReachedStart: boolean
}

export const MODAL_BEHAVIOUR_INITIAL_STATE: LuxKitModalBehaviourState = {
  bodyHasReachedEnd: true,
  bodyHasReachedStart: true,
}

export enum LuxKitModalBehaviourDispatchActions {
  TOGGLE_BODY_HAS_REACHED_END = 'TOGGLE_BODY_HAS_REACHED_END',
  TOGGLE_BODY_HAS_REACHED_START = 'TOGGLE_BODY_HAS_REACHED_START',
}

export type LuxKitModalBehaviourDispatchAction = ValueOf<Utils.FullActionMap<{
  [LuxKitModalBehaviourDispatchActions.TOGGLE_BODY_HAS_REACHED_END]: {
    hasReached: LuxKitModalBehaviourState['bodyHasReachedEnd']
  }
  [LuxKitModalBehaviourDispatchActions.TOGGLE_BODY_HAS_REACHED_START]: {
    hasReached: LuxKitModalBehaviourState['bodyHasReachedStart']
  }
}>>

export const luxKitModalBehaviourStateReducer = createReducer<LuxKitModalBehaviourState, LuxKitModalBehaviourDispatchAction>(
  MODAL_BEHAVIOUR_INITIAL_STATE,
  // @ts-ignore
  {
    [LuxKitModalBehaviourDispatchActions.TOGGLE_BODY_HAS_REACHED_END]: (_state, action) => ({
      bodyHasReachedEnd: action.hasReached,
    }),
    [LuxKitModalBehaviourDispatchActions.TOGGLE_BODY_HAS_REACHED_START]: (_state, action) => ({
      bodyHasReachedStart: action.hasReached,
    }),
  },
)
